















import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { getAppointmentType } from "@/lib/appointmentHelpers";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationAppointmentApproved",
  components: { ScreenNamePrinter, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const appointmentType = getAppointmentType(props.notification.details.appointment);

    return {
      appointmentType,
    };
  },
});
